// extracted by mini-css-extract-plugin
var _1 = "ApplicantCreditCheckSupplementary-modulerows__Rpske ApplicantCreditCheckBlock-modulerows__ENtqC";
export { _1 as "rows" }
